//External Libraries
import * as React from "react";
import { PINEntrySuccess } from "ouisys-engine/dist/reducers/pinFlow/PinTypes";
import {tracker} from "ouisys-engine/dist/reducers/strategy"

//Translations
import { Translate, injectIntl } from "../../localization/index";
import ChainRedirect from "../ChainRedirect";

const ThankYouStep = ({ finalUrl, isAlreadySubscribed }: PINEntrySuccess) => {

  //Redirect you can comment this out if you don't need it
  // React.useEffect(()=>{
  //   setTimeout(() => {
  //     if(typeof window != "undefined"){
  //       tracker.advancedInFlow('tallyman.v1-pin', 'portal-redirect', {url:finalUrl})

  //       window.location.href = finalUrl;
  //     }    
  //   }, 3000);

  // },[])

const chainRedirectUrl = typeof window != "undefined" ? window.pac_analytics.visitor.chainRedirectUrl : null;
return <div>
  <h3><Translate id="congratsTitle" defaultMessage="Congratulations!" /></h3>
  {
    isAlreadySubscribed &&

    <p><Translate id="AlreadySubscribed" defaultMessage="You are already a subscriber!" /></p>
    ||
    <p><Translate id="congratsText" defaultMessage="You have successfully enrolled in the service. Please check your SMS inbox for the product link." /></p>
  }
  {/* <a href={finalUrl}><Translate id="portalButton" defaultMessage="Go to portal page" /></a> */}

  {
    chainRedirectUrl &&
    <ChainRedirect chainRedirectUrl={chainRedirectUrl} />
  }
</div>

}

export default injectIntl(ThankYouStep);